<template>
  <div class="panel-div" style="position: relative;">
    <modal
      tokenType="skip"
      :show="editDialog"
      @cancel="closeSkipModal"
      @agree="editFollowupResponses"
    ></modal>
    <v-card
      ref="cardEl"
      flat
      :min-height="cardHeightMinimum"
      :max-height="cardHeightLimit"
      :class="panelClass"
      style="position: relative"
      class="d-flex flex-column panel">
      <v-card-title
        class="py-2 align-center justify-center" ref="drawerHandleEl">
        <v-container
          v-if="this.isMobileDevice()"
          class="pa-0"
          style="touch-action: none; width: 30%; height: 20px;"
          @touchstart="resizeTouchStart($event)">
          <v-row align="center" justify="center" fill-height no-gutters>
            <v-chip
              id="drawer-handle"
              align-center
              color="rgba(0, 0, 0, 0.2)"
              style="touch-action: none; height: 5px; width: 36px"
              >
            </v-chip>
          </v-row>
        </v-container>
      </v-card-title>

      <v-card-title
        id="prompt"
        class="question-prompt primaryblue--text pt-0 pb-2">
        <v-row no-gutters align="center">
          <v-col align="left" justify="center" >
            <mrx-translation :token="prompt"></mrx-translation>
          </v-col>
          <v-col style="max-width: fit-content" align="right" justify="center" >
            <v-btn :disabled="!videoMuted" style='background-color: transparent' @click="setVolume" v-if='volumeControl'>
              <v-icon size=24 color=primaryblue>{{ icons.mdiEarHearing }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-title
        v-if="shouldShowInstructions"
        class="instructions px-4 pb-1 pt-2"
        id="instructions"
        >
        <mrx-translation :token="instructions"></mrx-translation>
      </v-card-title>
      <mrx-translation :cssClasses="['infoMessage']" :token="labels.info"></mrx-translation>
      <mrx-translation :cssClasses="['warningMessage']" :token="labels.warning"></mrx-translation>
      <mrx-translation :display="showWarning" :cssClasses="[validationMessageClass]" :token="validationMessageToken"></mrx-translation>
      <mrx-translation :display="showPrefilled" :cssClasses="['infoMessage']" :token="labels.priorMessage"></mrx-translation>
      <v-card-text
        class="ma-0 pa-0 overflow-auto"
        ref="cardTextEl"
        @scroll="onScroll"
      >
        <scroll-arrow
          id="assessment-panel-scroll-arrow"
          :show="panel.input !== 'tapper' && hasOverflow"
          :style="overlayStyle"
          :arrowAlignment="arrowAlignment"
          v-on:scrollDown="instantScroll('down')"
          v-on:scrollUp="instantScroll('up')"
        ></scroll-arrow>
        <component
          class="pt-2"
          ref="componentEl"
          v-model="responses"
          :is="panel.input"
          :options="panel.options"
          :panelName="panel.name"
          :panelType="panel.type"
          :disabled="(panel.options && panel.options.disabled) || false"
          @warningEvent="warningEvent"
          @selectEvent="selectEvent"
          :style="componentStyle"
        >
        </component>
      </v-card-text>
    </v-card>

    <div class='faded-footer' :style="footerStyle"></div>
  </div>
</template>

<script>
  import RDTStatus from '@/components/inputs/RDTStatus';
  import Timer from '@/components/inputs/Timer';
  import Tapper from '@/components/inputs/Tapper';
  import Slider from '@/components/inputs/Slider';
  import AgeSlider from '@/components/inputs/AgeSlider';
  import TextInput from '@/components/inputs/TextInput';
  import Table from '@/components/inputs/Table';
  import Markdown from '@/components/inputs/Markdown';
  import DatePicker from '@/components/inputs/DatePicker';
  import MultiSelect from '@/components/inputs/MultiSelect';
  import MalariaTestNumber from '@/components/inputs/malaria/MalariaTestNumber';
  import MalariaRdtResult from '@/components/inputs/malaria/MalariaRdtResult';
  import MalariaAcquireSample from '@/components/inputs/malaria/MalariaAcquireSample';
  import BabyAgeDisplay from '@/components/inputs/BabyAgeDisplay';
  import BloodPressure from '@/components/inputs/BloodPressure';
  import DueDateDisplay from '@/components/inputs/DueDateDisplay';
  import Referral from '@/components/inputs/Referral';
  import Terms from '@/components/inputs/Terms';
  import ScrollArrow from "../layouts/ScrollArrow.vue"
  import languageLogic from '@/mixins/languageLogic'
  import { mapGetters } from 'vuex'
  import { panelFilters } from '@/mixins'
  import ui from '@/mixins/ui'
  import scrollArrow from '@/mixins/scrollArrow'
  import icons from '@/mixins/icons'
  import Modal from '../layouts/Modal.vue'

  export default {
    mixins: [panelFilters, languageLogic, ui, scrollArrow, icons],
    components: {
      multiselect: MultiSelect,
      slider: Slider,
      ageslider: AgeSlider,
      tapper: Tapper,
      datepicker: DatePicker,
      textinput: TextInput,
      tableinput: Table,
      markdown: Markdown,
      duedatedisplay: DueDateDisplay,
      babyagedisplay: BabyAgeDisplay,
      bloodpressure: BloodPressure,
      referral: Referral,
      malaria_rdt_test_number: MalariaTestNumber,
      malaria_rdt_aquire_sample: MalariaAcquireSample,
      malaria_rdt_result: MalariaRdtResult,
      timer: Timer,
      rdtstatus: RDTStatus,
      terms: Terms,
      ScrollArrow,
      Modal,
    },
    data() {
      return {
        showWarning: false,
        rangeValidation: null,
        showPrefilled: false,
        showInstructions: false,
        labels: {
          info: '',
          warning: '',
          error: '',
          priorMessage: ''
        },
        cardHeightMinimum: 0,
        cardHeightLimit: 0,
        cardBottom: 0,
        viewportHeight: window.innerHeight,
        cardHeight: 0,
        isTransparent: false,
        panelObserver: null,
        editDialog: false,
        videoMuted: true,
        timer: null,
      }
    },
    props: {
        maxPanelHeight: {
          type: Number,
          default: 0,
        },
        topPanelOffset: {
          type: Number,
          default: 0,
        },
        navPadding: {
          type: Number,
          default: 0,
        },
        showVolumeControl: {
          type: Boolean,
          default: false,
        }
    },
    async mounted() {
      this.resetHeight()
      this.cardObserver = new ResizeObserver(this.onPanelResize)
      window.scroll(0, 0)
      this.setLabels()
      this.observedElement = this.$refs.cardTextEl
      this.observeForOverflow()
      window.onresize = (e) => {
        this.viewportHeight = window.innerHeight
      }

      if (this.$refs.cardEl && this.$refs.cardEl.$el) {
        this.cardObserver.observe(this.$refs.cardEl.$el)
      }
    },
    computed: {
      info: {
        get() {
          return this.$store.state.v4.navigate.showInfo
        },
        set(val) {
          this.$store.commit('v4/navigate/set', { showInfo: val })
        }
      },
      panelClass() {
        let transparencyClassSuffix = 'opaque';
        if (this.isTransparent) {
          transparencyClassSuffix = 'transparent';
        }

        return `${this.cardClass()} panel-${transparencyClassSuffix}`
      },
      volumeControl() {
        if (this.panel.display === 'animated') {
          return this.showVolumeControl;
        } else {
          return false;
        }
      },
      prompt() {
        const token = `questions.${this.panel.name}.${this.promptType}`
        const tokenExists = this.$te(token, this.$i18n.locale)
        const tokenExistsInFallback = this.$te(token, this.$i18n.fallbackLocale)
        if (tokenExists || tokenExistsInFallback) {
          return token
        }
        return `questions.${this.panel.name}.prompt`
      },
      responses() {
        let responses = this.panel.responses
        let result
        try {
          if (this.panel.actions && this.panel.actions.filterResponses && !this.mode('dontFilterResponses')) {
            let selectedResponses = responses.filter(x => x.selected)
            let filteredResponses = this[this.panel.actions.filterResponses](responses)
            let filteredResponseIds = filteredResponses.map(x => x.id)
            selectedResponses.forEach(r => {
              filteredResponseIds.includes(r.id) ? r.selected = true : r.selected = false
            })
            result = filteredResponses
          }
        }
        catch (e) {}

        return result || responses
      },
      shouldShowInstructions() {
        return this.panel.type === 'multiple'
          || ['tapper', 'ageslider', 'bloodpressure'].includes(this.panel.input)
          || this.panel.options && this.panel.options.showInstructions
      },
      instructions() {
        if (this.panel.options && this.panel.options.showInstructions) {
          return `questions.${this.panel.name}.instructions`
        }
        let multiselectType = (this.panel.type === 'multiple') ? 'multiple_select' : 'single_select'
        const tokens = {
          ageslider: `questions.${this.panel.name}.instructions`,
          slider: `questions.${this.panel.name}.instructions`,
          tapper: `questions.${this.panel.name}.instructions`,
          multiselect: `app.inputs.${multiselectType}.instructions`,
          textinput: `app.inputs.${this.panel.input}.instructions`,
          datepicker: `questions.${this.panel.input}.instructions`,
          malaria_rdt_test_number: `questions.${this.panel.input}.instructions`,
          malaria_rdt_aquire_sample: `questions.${this.panel.input}.instructions`,
          malaria_rdt_result: `questions.${this.panel.input}.instructions`,
          bloodpressure: `questions.blood_pressure.instructions`
        }
        return tokens[this.panel.input]
      },
      panel() {
        let panel = this.$route.meta.collection === 'preference' ? this.preference : this.pan
        // Override input for heart_rate
        if (panel.name === 'heart_rate') {
          const hrInputMethod = this.$store.getters['v4/preference/getHeartRateInputMethod'];
          panel = { ...panel, input: hrInputMethod };
        }
        // Override input for respiratory_rate
        if (panel.name === 'respiratory_rate') {
          const rrInputMethod = this.$store.getters['v4/preference/getRespiratoryRateInputMethod'];
          panel = { ...panel, input: rrInputMethod };
        }
        return panel
      },
      footerStyle() {
        return {
          backgroundImage: this.footerBackground,
          height: this.navPadding + 'px'
        }
      },
      footerBackground() {
        var fadeColor = 'rgba(255,255,255,0.7)'
        if (this.cardClass() === 'intro-dark') {
          fadeColor = 'rgba(6, 25, 30, 1)'
        }
        return 'linear-gradient(to bottom, rgba(255,255,255,0), ' + fadeColor + ' 33%, ' + fadeColor + ' 100% )'
      },
      componentStyle() {
        return {
          flex: '1 1 100%',
          paddingBottom: this.navPadding + 'px'
        }
      },
      overlayStyle() {
        // override of scrollArrow overlay style
        return {
          paddingBottom: this.navPadding + 'px',
          height: this.cardContentVisibleHeight + 'px'
        }
      },
      initialMaxHeightOffset() {
        return this.topPanelOffset / 2
      },
      validationMessageClass() {
        return this.rangeValidation && this.rangeValidation.severity === 'warning' ? 'warningMessage' : 'errorMessage'
      },
      validationMessageToken() {
        return (this.rangeValidation && this.rangeValidation.messageToken) || this.labels.error
      },
      ...mapGetters({
        pan: 'v4/panel/current',
        preference: 'v4/preference/current',
        track: 'v4/track/current',
        mode: 'v4/mode/get',
        promptType: 'v4/track/promptType',
        editResponsesMode: 'v4/track/editResponsesMode',
        alreadyEditing: 'v4/track/editingFollowupResponses',
      }),
    },
    methods: {
      resetScrollPosition() {
        if (this.$refs.cardTextEl) {
          this.$refs.cardTextEl.scrollTop = 0;
        }
      },
      async selectEvent() {
        if (this.panel && this.panel.actions && this.panel.actions.onSelect) {
          await this[this.panel.actions.onSelect](this.panel.name)
        }
      },
      warningEvent(event) {
        if (typeof event === 'boolean') {
          this.rangeValidation = null
          this.showWarning = event
          return
        }
        this.rangeValidation = event
        this.showWarning = Boolean(event && ['warning', 'blocking'].includes(event.severity))
      },
      setVolume() {
        this.videoMuted = false;
        this.timer = setTimeout(() => {
          this.videoMuted = true;
          }, 7000);
      },
      resizeCard(e) {
        // get touch position and set height to the difference between it and card bottom
        const offset = e.touches[0].pageY
        const newHeight = this.cardBottom - offset
        let minHeight = this.navPadding

        if (this.$refs.drawerHandleEl) {
          minHeight = minHeight + this.$refs.drawerHandleEl.clientHeight
        }

        // limit size so it doesn't expand or shrink infinitely
        if (newHeight < this.maxPanelHeight && newHeight > minHeight) {
          this.cardHeightMinimum = newHeight
          this.cardHeightLimit = newHeight
        }
      },
      resizeTouchStart(e) {
        e.preventDefault()

        if (!this.$refs.cardEl || !this.$refs.cardEl.$el) return
        const el = this.$refs.cardEl.$el
        this.cardBottom=el.getBoundingClientRect().bottom
        window.addEventListener("touchmove", this.resizeCard, false)
        window.addEventListener("touchend", this.resizeTouchStop, false)
      },
      resizeTouchStop(e) {
        window.removeEventListener("touchmove", this.resizeCard, false)
        window.removeEventListener("touchend", this.resizeTouchStop, false)
      },
      async setLabels() {
        if (this.panel.input === 'tapper' && this.mode('useSliderForTapper')) {
          this.panel.input = 'slider'
        }
        this.labels = {
          info: `questions.${this.panel.name}.message.info`,
          warning: `questions.${this.panel.name}.message.warning`,
          error: `questions.${this.panel.name}.message.error`,
          priorMessage: 'dynamic.prior.token'
        }

        if (this.panel && this.panel.options && this.panel.options.prefilled) {
          this.showPrefilled = true
          this.labels.priorMessage = this.panel.options.disabled ? 'app.messages.prefilled_and_disabled.title' : 'app.messages.prefilled.title'
        }

        if (this.panel && this.panel.actions && this.panel.actions.beforePrompt) {
          let result = await this.$store.dispatch(`v4/panel/actions/${this.panel.actions.beforePrompt}`)
          this.labels.info = `questions.${this.panel.name}.message.${result}.info`
          this.labels.warning = `questions.${this.panel.name}.message.${result}.warning`
        }
      },
      setTransparent() {
        this.isTransparent = this.cardHeight >= this.maxHeight(this.topPanelOffset)
      },
      async resetHeight() {
        this.cardHeightMinimum = 0;
        // make the limit whichever is smaller - the content height that would show at least half the image
        // or the maximum height provided by the maxPanelHeight prop
        this.cardHeightLimit = Math.min(this.maxHeight(this.initialMaxHeightOffset), this.maxPanelHeight);
      },
      onPanelResize() {
        if (this.$refs.cardEl) {
          this.cardHeight = this.$refs.cardEl.$el.offsetHeight
        }
      },
      closeSkipModal() {
        this.editDialog = false
      },
      async editFollowupResponses() {
        this.$store.commit('v4/track/set', { editingFollowupResponses: true })
        await this.$store.dispatch('v4/navigate/next')
      },
      async determineShowEditDialog(nextPanel) {
        if (this.editDialog) {
          // if dialog is already open and we're continuing, we got consent and can close it and continue
          this.closeSkipModal()
        } else {
          // if it's not open, must check if dialog should show & check if editing consent has already been given
          if (this.editResponsesMode && !this.alreadyEditing) {
            // if in edit mode and next question needs answering, show dialog
            let shouldSkipNext = false
            if (nextPanel.actions && nextPanel.actions.beforeDisplay) {
              shouldSkipNext = await this.$store.dispatch('v4/panel/actions/shouldSkipPanel', nextPanel)
            }

            if (!shouldSkipNext) {
              // show popup
              this.editDialog = true
            }
          }
        }

        return
      },
      isSummaryPanel(panel) {
        return panel.name.toLowerCase() === 'summary'
      },
    },
    watch: {
      panel: {
        handler: function(val) {
          this.info = false
          this.showWarning = false
          this.rangeValidation = null
          this.resetScrollPosition()
          window.scroll(0, 0)
          this.resetHeight()
          this.setLabels()
          this.videoMuted = true
          clearTimeout(this.timer)
        },
      },
      viewportHeight: function(val) {
        this.resetHeight()
        this.setTransparent()
      },
      cardHeight: function(val) {
        this.setTransparent()
      },
      topPanelOffset: function(val) {
        this.setTransparent()
      },
      videoMuted() {
        this.$emit('videoMuted', this.videoMuted);
      }
    },
    async beforeRouteUpdate(to, from, next) {
      await this.determineShowEditDialog(to)
      if (this.editDialog) {
        return
      }

      this.showWarning = false
      this.rangeValidation = null
      this.showPrefilled = false
      if (this.panel && this.panel.actions && this.panel.actions.onLeave) {
        await this.$store.dispatch(`v4/panel/actions/${this.panel.actions.onLeave}`)
      }
      if (this.$store.getters['v4/mode/get']('disableRouterGuards')) { next() }
      else if (this.panel.type === 'report' && !['covid_counseling', 'followup_text_1', 'thinkmd_user_feedback'].includes(to.params.panels_name)) { next(false) }
      else { next() }
    },
    async beforeRouteLeave(to, from, next) {
      if (this.isSummaryPanel(to)) {
        const nextUnanswered = await this.$store.dispatch('v4/panel/next')
        if (!this.isSummaryPanel(nextUnanswered)) {
          await this.determineShowEditDialog(nextUnanswered)

          if (this.editDialog) {
            return
          }
        }
      }

      next()
    },
  }
</script>

<style scoped>
  .question-prompt {
    font-weight: 600;
    size: 18px;
    line-height: 1.1em;
  }
  .instructions {
    font-weight: 400;
    font-size: 14px;
    color:var(--dark-grey);
    line-height: 1.2rem;
  }
  .panel-div {
    width: 100%;
  }
  .rounded-b-0 {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .v-card {
    overflow: hidden;
  }
  .faded-footer {
    bottom: 0;
    width: 100%;
    position: absolute;
    min-height: 110px;
    z-index: 5;
  }
  .v-btn {
    outline-color: var(--deep-blue);
    outline-width: 2px;
    outline-style: solid;
  }
  .v-btn.v-btn--disabled {
    outline-color: var(--primary-blue-30);
    outline-width: 2px;
    outline-style: solid;
  }
</style>
